import { Observable } from "rxjs";
import { InjectionToken } from "@angular/core";
import { HttpHeaders, HttpParams } from "@angular/common/http";

export const HTTP_SERVICE = new InjectionToken("http service");

export interface HttpInterface {

  /**
   * Get base url as per url
   */
  getBaseUrl(): string;

  /**
   * Send get request
   * @param url 
   * @param params 
   * @param headers 
   */
  get<T>(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<T>;

  /**
   * Get file request
   * @param url
   * @param params
   * @param headers
   */
  getFile<T>(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<Blob>;

  /**
   * Send http post request
   * @param url
   * @param data
   */
  post<T>(url: string, data: any, headers?: HttpHeaders): Observable<T>;

  put<T>(url: string, data: any, headers?: HttpHeaders): Observable<T>;

  /**
 * Send http post request
//  * @param url
//  * @param id
//  */
  delete<T>(url: string, id?: any): Observable<T>;
}
